import { SimpleSocialLanding } from "@/components/SimpleSocialLanding";
import { BRAND_PERSON_NAME } from "@/lib/brandConfig";

const YouTube = () => (
  <SimpleSocialLanding
    seoPageKey="youtube"
    i18nPrefix="simplePages.youtube"
    imageAlt={`${BRAND_PERSON_NAME} - YouTube channel profile photo`}
  />
);

export default YouTube;
